import {
  Component,
  createNgModule,
  Injector,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewChild,
  ViewContainerRef,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { Observable } from 'rxjs';

import { CmsTemplate } from '@fcom/core-api';

@Component({
  selector: 'fin-render-lazy-wizard',
  templateUrl: './render-lazy-wizard.component.html',
  styleUrls: ['./render-lazy-wizard.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RenderLazyWizardComponent implements OnInit {
  private injector = inject(Injector);
  private platformId = inject(PLATFORM_ID);

  @ViewChild('lazyLoadComponent', { read: ViewContainerRef })
  lazyLoadComponent!: ViewContainerRef;

  @Input()
  template$: Observable<CmsTemplate>;

  ngOnInit(): void {
    // The lazy chunk is loaded via an untracked dynamic import(). On the server this
    // resolves after Angular has destroyed the app injector, so createNgModule() would
    // throw NG0205. This wizard is browser-only, so skip lazy loading during SSR.
    if (isPlatformBrowser(this.platformId)) {
      this.loadWizard();
    }
  }

  async loadWizard(): Promise<void> {
    const { MultiStepConditionalFormModule, MultiStepConditionalFormComponent } =
      await import('@fcom/service-forms-lazy/components/multi-step-conditional-forms');
    const moduleRef = createNgModule(MultiStepConditionalFormModule, this.injector);

    const { instance } = this.lazyLoadComponent.createComponent(MultiStepConditionalFormComponent, {
      ngModuleRef: moduleRef,
    });
    instance.template$ = this.template$;
  }
}
